module.exports = __webpack_public_path__ + "static/media/SOL.ee371a48.png";